var ExModule = (function () {
    function ExModule() {
    }
    return ExModule;
}());
export { ExModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/exercises/ex.module.ts.pre-build-optimizer.js